import {
    SAVE_BELSTAR_PAYMENT,
    SAVE_BELSTAR_AVAILABILITY,
    SET_UNIQUE_IDENTIFIER
} from "./types";

const initialStateBelstar = {
    memberSalutation: "",
    memberName: "",
    memberLastName: "",
    memberEmail: "",
    memberMobile: "",
    memberDOB: "",
    memberGender: "",
    memberAddress1: "",
    memberAddress2: "",
    memberAddress3: "",
    pinCode: "",
    loanId: "",
    branchId: "",
    sumInsured: "",
    memberRelationship: "",
    nomineeName: "",
    nomineeDOB: "",
    nomineeRelationship: "",
    uniqueIdentifier: "",
    preExistingDisease: "",
    productName: "",
}

const initialStateBelstarAvailable = {
    isVendorBelstar: false,
    uniqueIdentifier: ""
}

const belstarReducer = (state = initialStateBelstar, { type, payload }) => {
    switch (type) {
        case SAVE_BELSTAR_PAYMENT:
            return {
                ...initialStateBelstar,
                ...payload,
            };
        default:
            return state;
    }
};

const belstarAvailable = (state = initialStateBelstarAvailable, { type, payload }) => {
    switch (type) {
        case SAVE_BELSTAR_AVAILABILITY:
            return {
                ...initialStateBelstarAvailable,
                ...payload
            };
        case SET_UNIQUE_IDENTIFIER:
            return {
                ...initialStateBelstarAvailable,
                uniqueIdentifier: payload.uniqueIdentifier
            }
        default:
            return state;
    }
};

export { belstarReducer, belstarAvailable };
